<template>
  <router-view />
  <div class="z-10">
    <kt-dialog-manager
      v-for="dialog in dialogs"
      :key="dialog.key"
      :dialogKey="dialog.key"
      :component="dialog.component"
      :componentProps="dialog.componentProps"
      :onCancel="dialog.onCancel"
      :onOk="dialog.onOk"
    />
  </div>
</template>

<script>
import { KTComponent } from "metronics-vue";
import { dialog } from 'metronics-vue'

export default {
  mixins: [dialog],
  data() {
    return {
      dialogs: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      KTComponent.init();
    });
  },
};
</script>
